import { render, staticRenderFns } from "./URLs.vue?vue&type=template&id=336cf3fe&"
import script from "./URLs.vue?vue&type=script&lang=js&"
export * from "./URLs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports